import { render, staticRenderFns } from "./ComprovantePagamentoCartao.vue?vue&type=template&id=28d3ffa5"
import script from "./ComprovantePagamentoCartao.vue?vue&type=script&lang=js"
export * from "./ComprovantePagamentoCartao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports